import React, { useState, useContext } from 'react';
import { AuthContext } from './AuthContext';
import './AuthPage.scss';
import { Link, useNavigate } from 'react-router-dom';

const ForgotPasswordPage: React.FC = () => {
  const { forgotPassword } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleForgotPassword = async () => {
    if (!email) {
      setError('Please enter your email.');
      return;
    }

    try {
      await forgotPassword(email);
      // Redirect to reset password page
      navigate('/reset-password', { state: { email } });
    } catch (err) {
      setError('Failed to initiate password reset. Please try again.');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h2>Forgot Password</h2>
        {error && <p >{error}</p>}
        <div className="form-group">
          <label>Email</label>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
          />
        </div>
        <button className="cta-button" onClick={handleForgotPassword}>
          Reset Password
        </button>
        <div className="additional-links">
          <a href="/login">Go back to Sign In</a>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
